import { Map } from 'immutable';


const initialState = Map({
});

export const OrderReducer = (state = initialState, action) => {
  switch (action.type) {
    
    default:
      return state;
  }
};
